import React from 'react';
import { useData } from '../../context/DataContext';
import { computeGroupStats } from '../../utils/calculations';

export const GradeAvgCards = () => {
  const { getScopedStudents } = useData();

  const scoped = getScopedStudents();
  const grades = [...new Set(scoped.map(s => s.registeredGrade))].sort((a, b) => a - b);

  if (grades.length === 0) {
    return (
      <div className="mb-8 select-none">
        <h3 className="text-xl font-bold text-gray-800 mb-4">Grade-wise Average Score</h3>
        <p className="text-sm text-gray-400 italic">No data available.</p>
      </div>
    );
  }

  const color = '#1e3a5f';

  return (
    <div className="mb-8 select-none">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Grade-wise Average Score</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {grades.map((g) => {
          const stats = computeGroupStats(scoped.filter(s => s.registeredGrade === g));

          const pct = (v) => {
            return stats.participated > 0 ? Math.round((v / stats.participated) * 100) + '%' : '0%';
          };

          const scoreText = (v) => {
            return stats.participated > 0 ? Math.round(v) + '%' : '—';
          };

          return (
            <div
              key={g}
              className="bg-white rounded-2xl p-5 shadow border-l-4"
              style={{ borderColor: color }}
            >
              {/* Header */}
              <div className="flex items-center justify-between mb-3">
                <div className="font-bold text-gray-800 text-lg">Grade {g}</div>
                <span className="text-xs text-gray-500 font-semibold">
                  {stats.participated} of {stats.total} assessed
                </span>
              </div>

              {/* Averages Block */}
              <div className="flex items-end flex-wrap gap-6 mb-4">
                <div>
                  <p className="text-xs text-gray-500 font-bold uppercase tracking-wider">
                    Overall Avg
                  </p>
                  <p className="text-4xl font-black" style={{ color: color }}>
                    {scoreText(stats.avgOverall)}
                  </p>
                </div>

                <div className="flex gap-6">
                  <div>
                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider">
                      English
                    </p>
                    <p className="text-xl font-bold" style={{ color: '#2a6a4a' }}>
                      {scoreText(stats.avgEnglish)}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider">
                      Math
                    </p>
                    <p className="text-xl font-bold" style={{ color: '#1e3a9a' }}>
                      {scoreText(stats.avgMath)}
                    </p>
                  </div>
                </div>
              </div>

              {/* Performance Ratios */}
              <div className="flex flex-wrap gap-4 text-xs font-bold">
                <span style={{ color: '#2a6a4a' }}>● {stats.comp} Competent ({pct(stats.comp)})</span>
                <span style={{ color: '#d4870a' }}>● {stats.bridge} Bridge ({pct(stats.bridge)})</span>
                <span style={{ color: '#dc3545' }}>● {stats.remed} Remediation ({pct(stats.remed)})</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default GradeAvgCards;
